/**
 * Typed access to Vite environment variables. Only `VITE_`-prefixed variables are
 * exposed to the client; never put secrets here (see SECURITY.md).
 */
const raw = import.meta.env;

const readBoolean = (value: string | undefined, fallback: boolean): boolean =>
  value === undefined ? fallback : value === 'true';

export const env = Object.freeze({
  mode: raw.MODE,
  isDev: raw.DEV,
  isProd: raw.PROD,
  appName: raw.VITE_APP_NAME ?? 'VectorLoom',
  persistenceEnabled: readBoolean(raw.VITE_PERSISTENCE_ENABLED, true),
  debugOverlay: readBoolean(raw.VITE_DEBUG_OVERLAY, false),
});
